import { ExternalInfos } from '@/domain/external/entities/external.entity';
import {
  Scope,
  ScopeValues,
  Status,
  StatusValues,
} from '@/domain/external-invitation/entities/external-invitation.entity';
import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { PositionMapper } from '../position-geocode/position.mapper';
import { ExternalDto } from './external.dto.schema';

export class ExternalMapper {
  static dtoToEntity(dto: ExternalDto): ExternalInfos {
    return {
      id: dto.id,
      code: dto.code,
      userName: dto.name,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      scope: validateValueInType<Scope>(dto.scope, ScopeValues),
      expirationDate: dto.expirationDate,
      eventPosition: dto.eventPosition
        ? PositionMapper.dtoToEntity(dto.eventPosition)
        : undefined,
      title: dto.title || '',
      completion: Number(dto.completion),
      status: validateValueInType<Status>(dto.status || '', StatusValues),
      isValidated: dto.isValidated,
      projectId: Number(dto.projectId),
      projectInfos: {
        name: dto.projectName,
        location: dto.projectLocation || '',
        image: dto.projectImage || '',
        startDate: dto.projectStartDate
          ? new Date(dto.projectStartDate).toISOString()
          : null,
        endDate: dto.projectEndDate
          ? new Date(dto.projectEndDate).toISOString()
          : null,
      },
    };
  }
}
